/**
 * @generated SignedSource<<fdc33e930beba474b21afe513a315aff>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LoginCreateAccountEmailPreloaderQuery$variables = {
  email?: string | null | undefined;
  encryptedEmail?: string | null | undefined;
};
export type LoginCreateAccountEmailPreloaderQuery$data = {
  readonly hubspotLead: {
    readonly email: string;
    readonly firstName: string | null | undefined;
    readonly lastName: string | null | undefined;
  } | null | undefined;
};
export type LoginCreateAccountEmailPreloaderQuery = {
  response: LoginCreateAccountEmailPreloaderQuery$data;
  variables: LoginCreateAccountEmailPreloaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "encryptedEmail"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      },
      {
        "kind": "Variable",
        "name": "encryptedEmail",
        "variableName": "encryptedEmail"
      }
    ],
    "concreteType": "HubspotLead",
    "kind": "LinkedField",
    "name": "hubspotLead",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LoginCreateAccountEmailPreloaderQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "LoginCreateAccountEmailPreloaderQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "45f5582804626e9130788c9d77000e7a",
    "id": null,
    "metadata": {},
    "name": "LoginCreateAccountEmailPreloaderQuery",
    "operationKind": "query",
    "text": "query LoginCreateAccountEmailPreloaderQuery(\n  $email: String\n  $encryptedEmail: String\n) {\n  hubspotLead(email: $email, encryptedEmail: $encryptedEmail) {\n    email\n    firstName\n    lastName\n  }\n}\n"
  }
};
})();

(node as any).hash = "b29a4628b66cb16b878d92aadc1f5913";

export default node;
